import { ModelBase } from 'store/model-base';
import { ChargePlanGroup, ChargeType } from 'my-account/constants';

export class OrderItemCharge extends ModelBase {
    public static storeName: string = 'orderItemCharge';

    public type: ChargeType;
    public price: number;
    public name: string;
    public isUnlimited: boolean;
    public waive: boolean;
    public planGroup: string;
    public isActivationFee: boolean;
    public isSubsidy: boolean;
    public isDeviceAccessFee: boolean;
    public isDeviceFinanced: boolean;
    public isDevicePaid: boolean;
    public isLineServicePrimary: boolean;
    public isProtectionPlan: boolean;
    public isAppleCarePlan: boolean;
    public isAccessory: boolean;
    public isEWasteFee: boolean;
    public isDownPayment: boolean;
    public term: number;
    public isActivationWaived: boolean;
    public isCbeFee: boolean;

    public static create<T extends ModelBase>(initData: ApiResponse): T {
        initData.isDownPayment = initData.type === ChargeType.DOWN_PAYMENT;
        initData.isSubsidy = initData.type === ChargeType.DEVICE_SUBSIDY;
        initData.isDeviceAccessFee = initData.type === ChargeType.DEVICE_ACCESS_FEE;
        initData.isEWasteFee = initData.type === ChargeType.EWASTE_FEE;
        initData.isDeviceFinanced = initData.type === ChargeType.DEVICE_FINANCED;
        initData.isDevicePaid = initData.type === ChargeType.DEVICE_PURCHASED;
        initData.isLineServicePrimary = initData.type === ChargeType.LINE_SERVICE_PRIMARY;
        initData.isProtectionPlan = initData.type === ChargeType.INSURANCE_PLAN && (!initData.planGroup || initData.planGroup && initData.planGroup !== ChargePlanGroup.ACP);
        initData.isAppleCarePlan = initData.type === ChargeType.INSURANCE_PLAN && (initData.planGroup && initData.planGroup === ChargePlanGroup.ACP);
        initData.isAccessory = initData.type === ChargeType.ACCESSORY;
        initData.isActivationFee = initData.type === ChargeType.ACTIVATION_FEE && !initData.waive;
        initData.isActivationWaived = initData.type === ChargeType.ACTIVATION_FEE && initData.waive;
        initData.isCbeFee = initData.type === ChargeType.CBE_FEE;

        return super.create<T>(initData);
    }
}
